import React from "react";
// import "./TermsAndConditions.css";

const CancellationRefundPolicy = () => {
    return (
        <div className="tc-container">
            <h1 className="tc-title">Cancellation & Refund Policy</h1>

            <section className="tc-section">
                <h2>1. Cancellation Window</h2>
                <p>
                    Cancellation is allowed only before the order is confirmed by Way4Track.
                    An order is considered “confirmed” once it is verified and approved after payment.
                </p>
                <p>Once confirmed:</p>
                <ul>
                    <li>Inventory is reserved for the order</li>
                    <li>Processing and dispatch planning begins</li>
                    <li>Operational resources are committed</li>
                </ul>
                <p>
                    Due to these factors, cancellation is not possible after confirmation.
                </p>
            </section>

            <section className="tc-section">
                <h2>1A. Order Confirmation Timeline</h2>
                <p>
                    Orders are typically confirmed within a short duration after payment,
                    usually within a few minutes.
                </p>
                <ul>
                    <li>Inventory allocation</li>
                    <li>Order validation</li>
                    <li>Dispatch preparation</li>
                </ul>
                <p>
                    Once the status becomes “CONFIRMED”, cancellation is no longer possible.
                </p>
            </section>

            <section className="tc-section">
                <h2>2. Refund Eligibility</h2>
                <p>Refunds are processed only in specific cases:</p>
                <ul>
                    <li>Order cancelled before confirmation</li>
                    <li>Order cancelled by Way4Track due to operational reasons</li>
                </ul>
                <p>Refunds are not applicable in other situations.</p>
            </section>

            <section className="tc-section">
                <h2>3. No Refund After Confirmation</h2>
                <p>
                    Once confirmed, orders cannot be cancelled or refunded.
                </p>
                <ul>
                    <li>Inventory is already allocated</li>
                    <li>Processing has started</li>
                    <li>Operational costs are incurred</li>
                </ul>
                <p>
                    Refunds are not provided for change of mind or incorrect selection.
                </p>
            </section>

            <section className="tc-section">
                <h2>4. Shipping Adjustment</h2>
                <p>
                    If a partial cancellation is made before confirmation and the updated order
                    no longer qualifies for free shipping:
                </p>
                <ul>
                    <li>Shipping charges will be recalculated</li>
                    <li>Charges will be deducted from the refund</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>5. Refund Processing Time</h2>
                <p>
                    Approved refunds are initiated within 3–5 business days.
                </p>
                <p>
                    The actual credit time depends on the bank or payment provider.
                </p>
            </section>

            <section className="tc-section">
                <h2>6. Mode of Refund</h2>
                <p>
                    Refunds are issued only to the original payment method used.
                </p>
                <p>
                    Alternative refund modes are not supported.
                </p>
            </section>

            <section className="tc-section">
                <h2>7. Fraud Prevention</h2>
                <ul>
                    <li>Suspicious requests may be rejected</li>
                    <li>Accounts may be flagged for repeated misuse</li>
                    <li>Services may be restricted if required</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>8. Payment Disputes & Chargebacks</h2>
                <p>
                    Customers should not initiate disputes after confirmation without valid reasons.
                </p>
                <p>Way4Track may contest disputes using:</p>
                <ul>
                    <li>Transaction logs</li>
                    <li>Order details</li>
                    <li>Policy acceptance records</li>
                </ul>
            </section>

            <section className="tc-section">
                <h2>9. Cancellation Charges & Processing Fees</h2>
                <p>
                    Payment gateway charges may be deducted for cancellations made before confirmation.
                </p>
                <p>
                    These are third-party costs and are non-refundable.
                </p>
            </section>

            <section className="tc-section">
                <h2>10. Customer Responsibility</h2>
                <ul>
                    <li>Customer agrees to this policy before placing an order</li>
                    <li>Understands cancellation limitations</li>
                    <li>Confirms order details before payment</li>
                </ul>
            </section>

        </div>
    );
};

export default CancellationRefundPolicy;